<template>
    <div>
        <v-toolbar flat dense height="35">
            <v-btn-toggle
                mandatory
                color="accent"
            >
                <v-btn @click="changeType('day')" x-small color="white">
                    Dia
                </v-btn>
                <v-btn @click="changeType('week')" x-small color="white">
                    Semana
                </v-btn>
                <v-btn @click="changeType('month')" x-small color="white">
                    Mes
                </v-btn>
                <v-btn @click="changeType('custom')" x-small color="white">
                    <v-icon x-small :color="type === 'custom' ? 'accent': 'black'">mdi-calendar</v-icon>
                </v-btn>
            </v-btn-toggle>
            <v-spacer></v-spacer>
            <v-btn-toggle
                v-model="type_graph"
                mandatory
                color="accent"
            >
                <v-btn value="bar" x-small color="white">
                    <v-icon x-small :color="type_graph === 'bar' ? 'accent': 'black'">mdi-poll</v-icon>
                </v-btn>
                <v-btn value="area" x-small color="white">
                    <v-icon x-small :color="type_graph === 'area' ? 'accent': 'black'">mdi-chart-line-variant</v-icon>
                </v-btn>
            </v-btn-toggle>
        </v-toolbar>
        <v-divider></v-divider>
        <v-toolbar dense flat>
            <v-btn v-if="type !== 'custom'" @click="before" icon x-small class="mr-3">
                <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-spacer class="text-center text-caption font-weight-medium">
                {{description}}
            </v-spacer>
            <v-btn v-if="type !== 'custom'" @click="next" icon x-small class="ml-3">
                <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
        </v-toolbar>
        <v-card-text class="pa-0" :class="{ 'd-flex': data[type] && !data[type].loaded }" style="height: 40vh">
                <Chart 
                    v-if="type && data[type].loaded" 
                    :data="data[type]" 
                    :freq="freq" 
                    :type="type_graph"
                    :showXaxis="true"
                    ytitle="KWH"
                    @setDescription="setDescription"
                    style="height: 40vh"
                />
                <div 
                    v-else-if="type === 'custom' && datepickerObj.value == null"
                    class="ma-auto">
                        Selecciona un rango de fechas
                </div>
                <v-progress-circular
                    v-else
                    indeterminate
                    size="50"
                    color="accent"
                    class="ma-auto"
                ></v-progress-circular>
        </v-card-text>
    
        <datepicker 
            :open="datepickerObj.open" 
            @close="datepickerObj.open = false"
            @newValues="setCustomValues"/>
    </div>
</template>

<script>
import datepicker from '../datePicker'
import { mapActions } from 'vuex'
import Chart from '../../graphs/Chart'
export default {
    name: 'graphs',
    props: ['gateway', 'meters'],
    components: { Chart, datepicker },
    data() {
        return {
            type: null,
            type_graph: 'bar',
            freq: 'hour',
            description: '',
            datepickerObj:{
                open: false,
                value: null
            },
            data: {
                day:{
                    loaded: false,
                    series: [],
                    freq: 'hour'
                },
                week:{
                    loaded: false,
                    series: [],
                    freq: 'day'
                },
                month:{
                    loaded: false,
                    series: [],
                    freq: 'day'
                },
                custom:{
                    loaded: false,
                    series: [],
                    type: null,
                    times: null
                }
            }
        }
    },
    methods:{
        ...mapActions({
            getSummaryData: 'meters/getSummaryData'
        }),
        async getData(type, start){
            return this.getSummaryData({
                meters: this.meters,
                type,
                start
            })
        },
        setDescription(description){
            this.description = description
        },
        async dayData(){
            let today = new Date()
            this.setGraphData(today, today.getHours(), 'day')
        },
        async weekData(){
            const today = new Date()
            const start = new Date(today.getTime() - 1000 * 60 * 60 * 24 * 7)
            this.setGraphData(start, 7, 'month')
        },
        async monthData(){
            const month = new Date()
            const n_days = new Date(month.getFullYear(), month.getMonth() + 1, 0).getDate()
            month.setDate(1)
            this.setGraphData(month, n_days, 'month')
        },
        async setCustomValues(event){
            const { type, start } = event

            const freq = type === 'day' ? 'hour': 'day'
            this.freq = freq

            let len = 24
            if(type === 'month')
                len = new Date(start.getFullYear(), start.getMonth() + 1, 0).getDate()
      
            this.setGraphData(start, len, type)
            
        },
        before(){
            const start = this.data[this.type].categories[0]
            const day = 1000 * 60 * 60 * 24
            
            if(this.type === 'day')
                this.setGraphData(new Date(start.getTime() - day), 24, 'day')
            else if(this.type === 'week')
                this.setGraphData(new Date(start.getTime() - day * 7), 7, 'month')
            else if(this.type === 'month'){
                const month = start.getMonth()
                const before_month = month === 0 ? 11 : month - 1
                if(before_month === 11){
                    start.setYear(start.getFullYear() - 1)
                    start.setMonth(before_month)
                }
                else
                    start.setMonth(before_month)

                const n_days = new Date(start.getFullYear(), start.getMonth() + 1, 0).getDate()
                this.setGraphData(start, n_days, 'month')
            }
        },
        next(){
            const today = new Date()
            let start = this.data[this.type].categories[0]
            const end = this.data[this.type].categories[
                this.data[this.type].categories.length - 1
            ]
            const day = 1000 * 60 * 60 * 24

            if(this.type === 'day'){
                if(end.getDate() === today.getDate()) return

                const next_day = new Date(start.getTime() + day)
                const len = next_day.getDate() === today.getDate() 
                    ? today.getHours()
                    : 24

                this.setGraphData(next_day, len, 'day')
            }
            else if(this.type === 'week'){
                const next_week = new Date(start.getTime() + day * 7)
                if(next_week.getTime() > today.getTime()) return 

                this.setGraphData(next_week, 7, 'month')
            }
            else if(this.type === 'month'){
                const next_month = new Date(start)
                const month = start.getMonth()
                const next_month_number = month / 11 === 1 ? 0 : month + 1
                if(next_month_number === 0){
                    next_month.setYear(next_month.getFullYear() + 1)
                    next_month.setMonth(next_month_number)
                }
                else
                    next_month.setMonth(next_month_number)

                if(next_month.getTime() > today.getTime()) return
                
                const n_days = new Date(
                    next_month.getFullYear(), 
                    next_month.getMonth() + 1, 
                    0
                ).getDate()
                this.setGraphData(next_month, n_days, 'month')
            }
        },
        async setGraphData(start, len, type){
            try {
                this.data[this.type].loaded = false
                
                const STEP = {
                    hour: 1000 * 60 * 60,
                    day: 1000 * 60 * 60 * 24
                } 
                const CONDITION = {
                    hour: (read, time) => 
                            read.date.hour == time.getHours()
                            && read.date.day == time.getDate() 
                            && read.date.month == time.getMonth() + 1,
                    day: (read, time) => 
                            read.date.day == time.getDate() 
                            && read.date.month == time.getMonth() + 1
                }

                start.setHours(0,0,0,0)
                const architecture = this.gateway.hasOwnProperty('architecture') ? this.gateway.architecture : true
                const series = Array.from({ length: len })
                series.forEach( (time, index) => series[index] = start.getTime() + STEP[this.freq] * index )
                
                const responses = await this.getData(type, start)
                this.data[this.type].series = responses.map( (response, index) => {
                    let label = response.meter.name
                    if(this.meters[index].type == 'consumption')
                        if(architecture) label += '-Net'
                        else label += '-Con'
                    else label += '-Gen'
                    
                    if(response.status !== 200) return { name: label, data: [] }

                    const reads = response.data.data
                    const data = series.map( serie => {
                        const time = new Date(serie)
                        const read = reads.find( read => CONDITION[this.freq](read, time))
                        if(read)
                            return parseFloat(
                                read.measurements.netKwh.last - read.measurements.netKwh.first
                            ).toFixed(2)
                        else
                            return null
                    })

                    return {
                        name: label,
                        data: data
                    }
                } )
                
                const sum = { 
                    name: architecture ? 'Consumo' : 'Neto', 
                    data: new Array(len).fill(0) 
                }
                this.data[this.type].series.forEach( serie => {
                    let operation = 1
                    if(serie.name === 'Generación') operation = -1

                    serie.data.forEach( (value, i) => 
                        sum.data[i] = parseFloat((parseFloat(sum.data[i]) + (value * operation)).toFixed(2))
                    )
                })
                if(architecture) sum.data = this.removeNegatives(sum.data)
                this.data[this.type].series.push(sum)
                
                this.data[this.type].categories = series.map( h => new Date(h) )
                this.data[this.type].loaded = true
            } catch (error) {
                console.log(error)
            }
        },
        removeNegatives(values){
            return values.map( v => v < 0 ? 0 : v )
        },
        changeType(type){
            this.type = type
            this.freq = this.data[this.type].freq
            if(this.type === 'custom') return this.datepickerObj.open = true
            this[`${this.type}Data`]()
        },
        reset(){
            this.data.day.loaded = false
            this.data.week.loaded = false
            this.data.month.loaded = false
            this.data.custom.loaded = false
        }
    },
    watch:{
        gateway(){
            this.reset()
            if(this.type === 'custom') return
            if(this.type) this[`${this.type}Data`]()
        }
    },
    mounted(){
        this.changeType('day')
    }
}
</script>

<style scoped>
    .active{
        color: var(--v-accent-base) !important;
        background-color: white !important;
        box-shadow: 0 0 16px -9px black;
    }
    .v-chip{
        border-radius: 15px;
        font-size: 12px;
        height: 30px;
    }
    .v-chip:before {
        background-color: unset;
    }
    .content{
        /* height: 85%; */
        width: 100%;
        display: flex;
    }
    .line{
        border-left: 2px solid var(--v-primary-base);
        height: 13px;
    }
</style>